import { useState, useEffect } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { BreadCrumb } from "primereact/breadcrumb";
import Modal from "../../../components/modal/Modal";
import { Chip } from "primereact/chip";
import HashIbJuridico from "./HashIbJuridico";
import RegisterIbJuridico from "./RegisterIbJuridico";
import { getIbJuridico } from "../../../services/Settings/IbJuridico/getIbJuridico";
import { useQuery } from "react-query";
import { Skeleton } from "primereact/skeleton";
import IbJuridicoCreated from "./IbJuridicoCreated";
import { Button } from "primereact/button";
import { useAppContext } from "../../../context/AppContext";


const IbJuridicoConfig = () => {
  const { id } = useParams(); // get id
  const { state } = useLocation();
  const { permissions } = useAppContext();
  const [visible, setVisible] = useState(false); // Inicialmente oculto
  const [selected, setSelected] = useState(0);
  const [patch, setPatch] = useState(1);
  const classSelected = "bg-success text-white";


  const { data: ibjuridico_config, isLoading, refetch } = useQuery({
    queryKey: ["ibjuridico_config"],
    queryFn: () => getIbJuridico(),
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    enabled: !!permissions?.includes("168")//Ib Juridico
  });

  useEffect(() => {
    if (!isLoading) {
      if (ibjuridico_config?.token) {
        setSelected(3);
        setVisible(false);
      } else {
        setSelected(1);
        setVisible(true);
      }
    }
  }, [ibjuridico_config, isLoading]);

  const onSelectModal = (select) => {
    setSelected(select);
    setVisible(false);
  };

  const items = [
    {
      template: () => (
        <Link
          to={`/settings/ibjuridicoConfig`}
          state={{ name: state ? state.name : "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          Configurações Ib Juridico
        </Link>
      ),
    },
  ];

  // Verifica se `selected` é diferente de 3, e adiciona dinamicamente o Chip ao array de itens
  if (selected !== 3) {
    items.push({
      template: () => (
        <Chip
          label={selected === 1 ? "Cadastro" : "Token"}
          onClick={() => setVisible(true)}
          className="switch-type-btn"
          style={{ cursor: "pointer", border: "0.5px solid black" }}
        />
      ),
    });
  }

  const home = {
    template: () => (
      <Link to={"/salesManagement"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  return (
    <>
      <div className="d-flex justify-content-between">
        <div className="col-xl-8">
          <BreadCrumb
            model={items}
            home={home}
            style={{
              background: "transparent",
              border: "none",
              fontSize: "16px",
            }}
          />
        </div>
        <div className="col-xl-2">
          <Button
            // loading={loading}
            disabled={selected == 3 ? false : true}
            rounded
            label="Trocar"
            icon="fa fa-rotate"
            onClick={() => {
              setPatch(1)
              ibjuridico_config.token = "";
              setSelected(2);
            }}
            className="p-inputtext-sm me-2 m-auto w-100"
          />
        </div>
      </div>

      {isLoading ? (
        <Skeleton width="100%" height="400px" />
      ) : ibjuridico_config?.token && selected === 3 ? (
        <IbJuridicoCreated id={id} setVisible={setVisible} ibjuridico_config={ibjuridico_config} />
      ) : (
        <Modal
          visible={visible}
          dynamicTitle={"Selecione o método de integração"}
          onHide={() => setVisible(false)}
          closable={true}
        >
          <div className="row p-2 modal-switch">
            <div className="col-md-6 my-2">
              <div
                onClick={() => onSelectModal(1)}
                className={`card card-animation d-flex align-items-center p-5 ${selected === 1 && classSelected}`}
                style={{ borderRadius: "15px" }}
              >
                <h1 style={{ fontSize: "50px" }}>
                  <i className="fa-solid fa-business-time"></i>
                </h1>
                <h2>Cadastre-se</h2>
              </div>
            </div>
            <div className="col-md-6 my-2">
              <div
                onClick={() => onSelectModal(2)}
                className={`card card-animation d-flex align-items-center p-5 ${selected === 2 && classSelected}`}
                style={{ borderRadius: "15px" }}
              >
                <h1 style={{ fontSize: "50px" }}>
                  <i className="fa-solid fa-gavel"></i>
                </h1>
                <h2>Já tenho Cadastro</h2>
              </div>
            </div>
          </div>
        </Modal>
      )}

      {selected === 1 && !ibjuridico_config?.token && (
        <RegisterIbJuridico id={id} setVisible={setVisible} refetch={refetch} setSelected={setSelected} />
      )}
      {selected === 2 && !ibjuridico_config?.token && (
        <HashIbJuridico id={id} setVisible={setVisible} patch={patch} refetch={refetch} setSelected={setSelected} />
      )}
    </>
  );
};

export default IbJuridicoConfig;
